import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box, Collapse, IconButton, Table, TableBody, TableHead, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import SitemapSubGroupRow from "./SitemapSubGroupRow";
import { isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import { SitemapButtonTableCell, SitemapEmptyListAlert } from "./SitemapEdit";
import {
  sitemapGroupCreationValuesOnEdit,
  sitemapSubGroupCreationInitialValues,
} from "../../../../../init/sitemapCreationInitialValues";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openDeleteModal, openEditModal } from "../../../../../store/redux/slice/ComponentsControl/sitemapControl";
import { sitemapSection } from "../../../../../utils/constants";

type SitemapGroupRowProps = {
  sitemapItem: any;
};

const SitemapGroupRow = ({ sitemapItem }: SitemapGroupRowProps) => {
  const dispatch = useAppDispatch();

  const onClickEditGroupButton = (existedGroup) => {
    dispatch(openEditModal({ section: sitemapSection.group, object: existedGroup }));
  };

  const onClickDeleteGroupButton = (id) => {
    dispatch(openDeleteModal({ section: sitemapSection.group, id: id }));
  };

  const onClickCreateSubGroupButton = (mainGroupId) => {
    dispatch(
      openEditModal({
        section: sitemapSection.subGroup,
        object: { ...sitemapSubGroupCreationInitialValues, mainGroupId: mainGroupId },
      }),
    );
  };

  const [openGroup, setOpenGroup] = useState(false);
  const { t } = useTranslation();
  const group = sitemapItem.mainGroup;
  const subGroups = sitemapItem.subGroups;
  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenGroup(!openGroup)}>
            {openGroup ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{group.id}</TableCell>
        <TableCell>{group.name}</TableCell>
        <TableCell>{group.nameEn}</TableCell>
        <TableCell align="center">{group.position}</TableCell>
        <SitemapButtonTableCell>
          <TableButton
            type={"edit"}
            onClick={() =>
              onClickEditGroupButton(
                sitemapGroupCreationValuesOnEdit({
                  id: group.id,
                  name: group.name,
                  nameEn: group.nameEn,
                  position: group.position,
                }),
              )
            }
          />
          <TableButton
            onClick={() => {
              onClickDeleteGroupButton(group.id);
            }}
            type={"remove"}
          />
        </SitemapButtonTableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openGroup} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {t("l.table.head.subGroups")}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead style={{ background: "#eee" }}>
                  <TableRow>
                    <TableCell style={{ width: 35 }} />
                    <TableCell>{t("l.table.head.id")}</TableCell>
                    <TableCell>{t("l.table.head.subGroupName")}</TableCell>
                    <TableCell>{t("l.table.head.subGroupNameEn")}</TableCell>
                    <TableCell>{t("l.table.head.position")}</TableCell>
                    <TableCell align="right">
                      <TableButton type={"create"} onClick={() => onClickCreateSubGroupButton(group.id)} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isArrayNotEmpty(subGroups) && (
                  <TableBody>
                    {subGroups.map((subGroup) => (
                      <SitemapSubGroupRow key={subGroup.id} subGroup={subGroup} />
                    ))}
                  </TableBody>
                )}
              </Table>
              {isArrayEmpty(subGroups) && (
                <SitemapEmptyListAlert severity="info">{t("m.empty.list")}</SitemapEmptyListAlert>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default SitemapGroupRow;
